import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import {
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClassNameGenerator from "@mui/utils/ClassNameGenerator";
import moment from "moment";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottom: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function ImageView(props) {
  const { button, title, width, open, setOpen, imageUrl } = props;

  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    overflow: "hidden",
    height: "50vh",
    overflow: "auto",
  };
  const openimage=(url)=>{
    window.open(url)
  }

  console.log(imageUrl, "imaghhhhheUrl");

  return (
    <div>
      {/* <Button onClick={() => handleOpen(rowData)}>
        {button === "icon" ? (
          <IconButton>
            <InfoIcon />
          </IconButton>
        ) : (
          button
        )}
      </Button> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent:"flex-start",
                flexWrap:"wrap",
                gap: "10px",
              }}
            >

              {/* <ImageList
                 cols={3}
              > */}
                {imageUrl &&
                  imageUrl.length > 0 &&
                  Array.isArray(imageUrl) &&
                  imageUrl.map((val, i) => {
                    console.log(val, "djfheurfeuryf");
                    return (
                      <>
                        <ImageListItem key={i}>
                          <img
                            src={val}
                            srcSet={val.fileUrl}
                            alt={"Images"}
                            loading="lazy"
                            style={{ width: "200px",height:"200px", margin: "10px" }}
                            onClick={()=>openimage(val)}
                          />
                          
                        </ImageListItem>
                       
                      </>
                    );
                  })}
              {/* </ImageList> */}
             
            </Box>
          </ModalBody>
        </Box>
      </Modal>
    </div>
  );
}
